export class Globals {
  static readonly demoUrlId: string = 'DEMO';
}